import React, { useState, useContext, useEffect } from 'react';

import Box from '@mui/material/Box';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

import {
    get as _get,
} from 'lodash';

import Auth from '../../../../data/auth-service';
import DataContext from '../../../../data/data-context';

import None from './none';
import LDAP from './ldap';
import Okta from './okta';
import SAML from './saml';

const External = (props) => {
    const { systemSettings } = useContext(DataContext);
    const [externalTabValue, setExternalTabValue] = useState(0);
    const externalPerms = Auth.permissions.get('AuthenticationExternal');

    useEffect(() => {
        if (systemSettings && systemSettings.auth) {
            if (systemSettings.auth.okta.enabled) {
                setExternalTabValue(2);
            } else if (systemSettings.auth.saml.enabled) {
                setExternalTabValue(3);
            } else if (_get(systemSettings, 'auth.ldap.bind_connection') &&
                !_get(systemSettings, 'auth.ldap.disabled')) {
                setExternalTabValue(1);
            }
        }
    }, [systemSettings]);

    const handleExternalAuthSourceChanged = tab => {
        setExternalTabValue(tab);
    };

    return (
        <Box>
            <ButtonGroup disabled={!externalPerms.admin}>
                <Button variant={externalTabValue === 0 ? 'contained' : 'outlined'} color="primary" aria-label="none" onClick={() => { handleExternalAuthSourceChanged(0) }}>None</Button>
                <Button variant={externalTabValue === 1 ? 'contained' : 'outlined'} color="primary" aria-label="ldap" onClick={() => { handleExternalAuthSourceChanged(1) }}>LDAP</Button>
                <Button variant={externalTabValue === 2 ? 'contained' : 'outlined'} color="primary" aria-label="okta" onClick={() => { handleExternalAuthSourceChanged(2) }}>Okta</Button>
                <Button variant={externalTabValue === 3 ? 'contained' : 'outlined'} color="primary" aria-label="saml" onClick={() => { handleExternalAuthSourceChanged(3) }}>SAML</Button>
            </ButtonGroup>
            {externalTabValue === 0 && <Box p={2} value={externalTabValue} index={0}>
                <None />
            </Box>}
            {externalTabValue === 1 && <Box p={2} value={externalTabValue} index={1}>
                <LDAP />
            </Box>}
            {externalTabValue === 2 && <Box p={2} value={externalTabValue} index={2}>
                <Okta />
            </Box>}
            {externalTabValue === 3 && <Box p={2} value={externalTabValue} index={3}>
                <SAML />
            </Box>}
        </Box>
    );
};

export default External;
